export default __webpack_public_path__ + "static/media/story-2.09062038.jpg";